// extracted by css-extract-rspack-plugin
export default {"root":"Card_root__1sg+N"};